import React, { useEffect } from "react";
import styled from "styled-components";
import { changeAndAddMetaTags } from "../utilities/helpers";
import TermsAndConditionsContent from "../components/PagesComponents/TermsAndConditionsContent";
import FAQContent from "../components/PagesComponents/FAQContent";
const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  padding: 0.2rem;
`;

const FAQ = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    changeAndAddMetaTags(
      "FAQ | Best Catering Food Service Online London",
      "FAQ | Best Catering Food Service Online London",
      document.URL
    );
  }, []);

  return (
    <Container>
      <FAQContent />
    </Container>
  );
};

export default FAQ;
